import { Mail, MessageCircle } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { scrollToSection } from "@/components/SmoothScroll";
import { Logo } from "@/components/Logo";

const Footer = () => {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  return (
    <footer className="relative overflow-hidden bg-[#1A1A1A] pb-10 pt-16 text-[#FDFBF7] md:pt-20" data-testid="section-footer">
      <div className="mx-auto max-w-7xl px-6">
        <div className="flex flex-col justify-between gap-12 md:flex-row md:items-start">
          <div>
            <Logo light />
            <p className="mt-6 max-w-sm font-display text-2xl font-medium italic leading-snug text-white/85">
              {t.footer.tagline}
            </p>
          </div>

          <div>
            <p className="text-xs font-medium uppercase tracking-[0.28em] text-white/50">{t.footer.explore}</p>
            <ul className="mt-5 space-y-3">
              {t.nav.links.map((link) => (
                <li key={link.href}>
                  <button
                    type="button"
                    onClick={() => scrollToSection(link.href)}
                    data-testid={`footer-link-${link.href.replace("#", "")}`}
                    className="text-sm text-white/70 transition-colors duration-300 hover:text-white"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-xs font-medium uppercase tracking-[0.28em] text-white/50">{t.footer.contact}</p>
            <ul className="mt-5 space-y-3">
              <li>
                <a
                  href="https://wa.me/32451075502"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-whatsapp-link"
                  className="inline-flex items-center gap-2.5 text-sm text-white/70 transition-colors duration-300 hover:text-white"
                >
                  <MessageCircle className="h-4 w-4 text-[#25D366]" />
                  +32 451 075 502
                </a>
              </li>
              <li>
                <a
                  href="mailto:irislanguagesacademy@hotmail.com"
                  data-testid="footer-email-link"
                  className="inline-flex items-center gap-2.5 text-sm text-white/70 transition-colors duration-300 hover:text-white"
                >
                  <Mail className="h-4 w-4 text-[#45B7D1]" />
                  irislanguagesacademy@hotmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center gap-4 border-t border-white/10 pt-8 md:flex-row md:justify-between">
          <p className="text-xs text-white/50">© {year} Iris Languages Academy. {t.footer.rights}</p>
          <p className="font-display text-sm italic text-white/60">{t.footer.closing}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
